import _ from "lodash";

class Utils {
  /**
   * @deprecated too complex for a so easy task.
   *
   * Returns new object with extracted properties from the original one and
   * keys you defined. Useful for using at dropdowns.
   *
   * @param {Array} list array of elements to parse.
   * @param {Array} properties property names to extract
   * @param {Array} names names you want yo have as keys for the new object
   */
  subObject(list, properties, names) {
    const output = [];

    list.forEach(item => {
      const extracted = _.pick(item, properties);
      const newObj = {}

      Object.values(extracted).forEach((val, i) => {
        newObj[names[i]] = val
      })

      output.push(newObj);

    });

    return output
  }

}

export default new Utils();